import { render } from "./BottomPanel.vue?vue&type=template&id=00b88a64"
import script from "./BottomPanel.vue?vue&type=script&lang=js"
export * from "./BottomPanel.vue?vue&type=script&lang=js"

import "./BottomPanel.vue?vue&type=style&index=0&id=00b88a64&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__